"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMeltingPoint = void 0;
const physical_parser_1 = require("physical-parser");
const extractExperimentalData_1 = require("./extractExperimentalData");
/**
 * Returns the melting point of a compound
 * @param data Data of a compound data request to the PubChem API
 * @param options Options for the compound
 * @returns ExperimentalData
 */
function getMeltingPoint(data, options = {}) {
    const meltingPoint = (0, extractExperimentalData_1.extractExperimentalData)(data, 'Melting Point', {
        parser: (value) => (0, physical_parser_1.parseNumbersUnits)(value, options.temperature),
    });
    return meltingPoint;
}
exports.getMeltingPoint = getMeltingPoint;
//# sourceMappingURL=getMeltingPoint.js.map